export const MONTH = 'MONTH';
export const WEEK = 'WEEK';
